import { useTranslation } from 'react-i18next'

import { Badge } from '@enechain/ecloud-designsystem'

type Props = {
  /** 取り込み元で見つからなくなった札か (AC-BIN-127)。 false なら何も描画しない。 */
  needsReview: boolean | undefined
}

/**
 * 「要確認」の印 (AC-BIN-127)。 ステータスは変わらないので、 ステータスバッジとは別軸の
 * チップとして横に併記する。 入札一覧と板発注の自社入札表が共有する。
 */
export const IntradayNeedsReviewChip = ({
  needsReview,
}: Props): React.ReactElement | null => {
  const { t } = useTranslation()
  if (needsReview !== true) return null
  return (
    <Badge
      marginLeft={1}
      status="warning"
      title={t('page:biddingIntraday.needsReview.chipTitle')}
    >
      {t('page:biddingIntraday.needsReview.chip')}
    </Badge>
  )
}
